<template>
  <div>
    <a-row>
      <g-master name="evaluados"
                :endpoint="employeeMaster.endpoint"
                :tableSetup="employeeMaster.tableSetup"
                :parentData="evParentData"
                :modalFieldsSetup="employeeMaster.modalFieldsSetup"
                @action="masterAction"
                @params="paramsTable"
      >
        <template slot="customButton">
          <g-btn-excel :endpoint="`${employeeMaster.endpoint}_/downloadExcel`" :params="paramsExcel" fileName="evaluados"/>
        </template>
        <template slot="masterModal" slot-scope="{record}">
          <a-row :gutter="[16,16]">
            <a-col v-bind="colOptions">
              <g-lookup label="Empleado"
                        :formItemConfig="fiOptions"
                        endpoint="empleados"
                        ref="empleado"
                        :params="{estado_activo: true}"
                        :selectedObj.sync="empleadoSeleccionado"
                        :decorator="['id_evaluated', { rules: [{ required: true, message: 'Valor requerido' }] }]"
              >
              </g-lookup>
            </a-col>
            <a-col v-bind="colOptions">
              <g-dropdown :label="$t('Nivel de cargo')"
                          :formItemConfig="fiOptions"
                          endpoint="level_competency"
                          :params="{filtra_por_empleado: true, id_evaluation: id_evaluation, empleado_seleccionado: empleadoSeleccionado}"
                          :decorator="['id_level_competency', { rules: [{ required: true, message: 'Valor requerido' }] }]">
              </g-dropdown>
            </a-col>
          </a-row>
        </template>
      </g-master>
    </a-row>
    <a-row>
      <a-tabs defaultActiveKey="1">
        <a-tab-pane tab="LISTADO DE EVALUADORES" key="1">
          <evaluadores v-if="idEvaluadores" :id_employee_evaluated="idEvaluadores"
                       :id_evaluation="id_evaluation"></evaluadores>
          <span v-else>Seleccione para ver los evaluadores.</span>

        </a-tab-pane>
      </a-tabs>
    </a-row>
  </div>
</template>
<script>
  // Segunda Tab: COMPETENCIAS --> Rh_t_competency
  // Objetivos por competencia -> rh_t_behavior

  export default {
    data () {
      return {
        empleadoSeleccionado: {},
        colOptions: {xs: 24, sm: 24},
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        employeeMaster: {
          actions: {
            actions: [
              {
                name: 'masterEdit',
                text: 'Editar',
                permisos: [],
                props: {size: 'small', type: 'link', icon: 'edit'}
              },
              {
                name: 'masterDelete',
                text: 'Eliminar',
                permisos: [],
                props: {size: 'small', icon: 'delete', type: 'link'}
              }
            ]
          },
          endpoint: 'employee_evaluated',
          tableSetup: {
            allowSelect: true,
            selectedRows: [],
            tableConfig: {
              rowKey: 'id_employee_evaluated'
            },
            columns: [
              {title: 'Código', dataIndex: 'id_evaluated', sorter: true},
              {title: 'Nombre', dataIndex: 'nombre', sorter: true},
              {title: 'Cargo', dataIndex: 'cargo', sorter: true},
              {title: 'Nivel de cargo', dataIndex: 'competency_desc', sorter: true},
              {title: 'Empresa', dataIndex: 'company_desc', sorter: true},
              {title: 'Inicio del contrato', dataIndex: 'initial_date_mask', sorter: true},
              {title: 'Estado', dataIndex: 'estado', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'id_evaluated'},
            {name: 'company'},
            {name: 'id_job'},
            {name: 'id_level_competency'}
          ]
        },
        paramsT: {}
      }
    },
    methods: {
      masterAction (action) {
        switch (action.action) {
          case 'masterCreate':
            this.empleadoSeleccionado = {}
            break
          case 'masterEdit':
            if (!this.$isEmpty(action.record.id_evaluated)) {
              this.$refs.empleado && this.$refs.empleado.handleSearch(action.record.id_evaluated)
              if (!this.$isEmpty(action.record.id_job)) {
                this.empleadoSeleccionado = {id_emp: action.record.id_evaluated, id_cargo: action.record.id_job}
              }
            }
            break
        }
      },
      paramsTable (params) {
        this.paramsT = params
      }
    },
    props: ['id_evaluation'],
    computed: {
      evParentData () {
        return {
          id_evaluation: this.id_evaluation
        }
      },
      idEvaluadores () {
        return this.employeeMaster.tableSetup.selectedRows.length > 0 ? this.employeeMaster.tableSetup.selectedRows[0].id_employee_evaluated : null
      },
      paramsExcel () {
        return {...this.paramsT, columns: this.employeeMaster.tableSetup.columns}
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Evaluaciones/Evaluados.vue